import {postJson,downFileJson} from "./http"
const baseUrl = '/api/kmc/pc/vlivev2';
//获取直播活动列表
export const getLiveEventList = v => postJson(`${baseUrl}/getLiveEventList`, v.data, v.success, v.error)
//新建/修改直播
export const uploadLiveEventInfo = v => postJson(`${baseUrl}/uploadLiveEventInfo`, v.data, v.success, v.error)
//获取可添加主播列表
export const getLiveHistoryHeaderList = v => postJson(`${baseUrl}/getLiveHistoryHeaderList`, v.data, v.success, v.error)
//获取直播活动详情
export const getLiveEventInfo = v => postJson(`${baseUrl}/getLiveEventInfo`, v.data, v.success, v.error)
//获取直播已添加主播列表
export const getLiveEventHeaderList = v => postJson(`${baseUrl}/getLiveEventHeaderList`, v.data, v.success, v.error)
//提交主播修改信息
export const uploadLiveEventHeaderInfo = v => postJson(`${baseUrl}/uploadLiveEventHeaderInfo`, v.data, v.success, v.error)
//删除直播
export const deleteVliveEndStatus = v => postJson(`${baseUrl}/deleteVliveEndStatus`, v.data, v.success, v.error)
//获取去直播推流信息
export const getGoVliveAdressInfo = v => postJson(`${baseUrl}/getGoVliveAdressInfo`, v.data, v.success, v.error)
//获取直播活动相关地址信息
export const getVliveAdressInfo = v => postJson(`${baseUrl}/getVliveAdressInfo`, v.data, v.success, v.error)
//获取直播推流状态
export const getVliveStreamStatus = v => postJson(`${baseUrl}/getVliveStreamStatus`, v.data, v.success, v.error)
//直播信息-结束直播
export const updateVliveEndStatus = v => postJson(`${baseUrl}/updateVliveEndStatus`, v.data, v.success, v.error)
//获取播放设置 直播活动
export const getVliveEventBriefInfo = v => postJson(`${baseUrl}/getVliveEventBriefInfo`, v.data, v.success, v.error)
//获取直播活动可关联活动信息
export const getRelEventListByLive = v => postJson(`${baseUrl}/getRelEventListByLive`, v.data, v.success, v.error)
//获取直播活动的播放设置信息
export const getLiveEventPlaySettingInfo = v => postJson(`${baseUrl}/getLiveEventPlaySettingInfo`, v.data, v.success, v.error)
//提交保存关联活动设置
export const uploadLiveRelEventInfo = v => postJson(`${baseUrl}/uploadLiveRelEventInfo`, v.data, v.success, v.error)
//提交保存暖场设置
export const uploadLivePreviewSetting = v => postJson(`${baseUrl}/uploadLivePreviewSetting`, v.data, v.success, v.error)
//提交保存互动设置
export const uploadLiveInteractiveSetting = v => postJson(`${baseUrl}/uploadLiveInteractiveSetting`, v.data, v.success, v.error)
//获取直播评论列表
export const getLiveEventCommentsList = v => postJson(`${baseUrl}/getLiveEventCommentsList`, v.data, v.success, v.error)
//隐藏/显示评论信息
export const uploadCommentDisplayStatus = v => postJson(`${baseUrl}/uploadCommentDisplayStatus`, v.data, v.success, v.error)
//提交保存防盗设置
export const uploadLiveSecuritySettings = v => postJson(`${baseUrl}/uploadLiveSecuritySettings`, v.data, v.success, v.error)
//获取直播数据在线人数数据
export const getLiveEventLineChartByDay = v => postJson(`${baseUrl}/getLiveEventLineChartByDay`, v.data, v.success, v.error)
//获取直播观看详情
export const getLiveEventViewInfoByUser = v => postJson(`${baseUrl}/getLiveEventViewInfoByUser`, v.data, v.success, v.error)
//获取直播观看详情用户信息
export const getLiveEventUserInfo = v => postJson(`${baseUrl}/getLiveEventUserInfo`, v.data, v.success, v.error)
//导出直播观看详情
export const getLiveEventViewInfoByExport = v => downFileJson(`${baseUrl}/getLiveEventViewInfoByExport`, v.data, v.success, v.error)
//获取导出评论信息
export const getExportComment = v => downFileJson(`${baseUrl}/getExportComment`, v.data, v.success, v.error)
//用户禁言/解除禁言
export const bannedVliveUser = v => postJson(`${baseUrl}/bannedVliveUser`, v.data, v.success, v.error)
